'use client';

import { CacheKeys } from '@headless-workspace/config';
import { useSWRConfig } from 'swr';

export const useUserDataRevalidation = () => {
    const { mutate } = useSWRConfig();

    const revalidateAll = async () => {
        await Promise.all([
            mutate(CacheKeys.User),
            mutate(CacheKeys.Basket),
            mutate(CacheKeys.FavoriteStore),
            mutate(CacheKeys.Wishlist),
        ]);
    };

    return { revalidateAll };
};
